import { Button } from "@/components/button";

import type { ChoicesData } from "../../types/mbc-chat.types";

type ChoicesPartProps = {
  choices: ChoicesData;
  isDisabled: boolean;
  onSelect: (label: string) => void;
};

export function ChoicesPart({
  choices,
  isDisabled,
  onSelect,
}: ChoicesPartProps) {
  return (
    <div className="mt-md flex flex-wrap gap-sm">
      {choices.options.map((option) => (
        <Button
          className="rounded-full"
          isDisabled={isDisabled}
          key={option.id}
          onPress={() => onSelect(option.label)}
          size="sm"
          variant="secondary"
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}
